import React from 'react';
import { usePreviewState } from '../DJPal/DJPalAudioPreview';
import { ReactComponent as PlayIcon } from '../../assets/icons/play.svg';
import { ReactComponent as PauseIcon } from '../../assets/icons/pause.svg';

// DESIGN V2 — the hero Play on artist / track / label pages. It plays a row of
// the page (by previewId), so it mirrors that row: spinner while it loads,
// Pause while it plays. Before, it never changed and a click read as a miss.
export default function HeroPlayButton({ previewId, onClick, title, label = 'Play', disabled = false }) {
    const { loading, playing } = usePreviewState(previewId);
    const play = onClick || (() => window.dispatchEvent(new CustomEvent('djpal-row-play', { detail: previewId })));
    return (
        <button type="button" className={`v2-btn primary${playing ? ' playing' : ''}`} onClick={play} disabled={disabled} title={playing ? 'Pause' : title} aria-busy={loading || undefined}>
            {loading ? <span className="mix-play-spinner" aria-hidden="true" /> : (playing ? <PauseIcon /> : <PlayIcon />)}
            {playing ? 'Pause' : label}
        </button>
    );
}
